import { FileTypes } from "../models";

const { jpg, png, webp } = FileTypes;
const imageTypes = new Set([jpg, png, webp]);

export const isImage = (type: string): boolean => imageTypes.has(type as FileTypes);
